jQuery(document).ready(function($){
    if ( $('.nf-insights-slider') ) {
        var slider = $('.nf-insights-slider__wrapper');
        var nextbut = slider.parent().find('.next-arrow');
        var prevbut = slider.parent().find('.prev-arrow');

        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 3,
            dots: false,
            arrows: true,
            prevArrow: prevbut,
            nextArrow: nextbut,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 993,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        fade: true,
                        centerMode: false,
                        focusOnSelect: false,
                    }
                }
            ]
        });
    }


    if($('.featured-slider')) {
        var slider = $('.featured-slider-slides');
        var nextbut = slider.parent().find('.nextbut');
        var prevbut = slider.parent().find('.prevbut');
        $(slider).slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: true,
            arrows: true,
            appendDots: $('.featured-slider-dots'),
            nextArrow: nextbut,
            prevArrow: prevbut,
            infinite: true
        });
    }
});